// Main Product Page Optimized JavaScript
// 統合された機能: モバイルカート、コピー機能、スライダー、タブ、営業日計算

document.addEventListener('DOMContentLoaded', function() {
  // ===== モバイルカート機能 =====
  initMobileCart();
  
  // ===== コピー機能 =====
  initCopyButtons();
  
  // ===== タブ機能 =====
  initProductTableTabs();
  initUsageFlowTabs();
  
  // ===== スライダー機能 =====
  initProductSliders();
  
  // ===== 営業日計算 =====
  initBusinessDayCalculation();
  
  // ===== お客様の声スライダー =====
  initVoiceSlider();
  
  // ===== IE対応 =====
  initIEFallback();
});

// モバイルカート機能
function initMobileCart() {
  if (window.innerWidth < 750) {
    // セクションIDを動的に取得
    const sectionInput = document.querySelector('input[data-section-id]');
    if (!sectionInput) return;
    
    const sectionId = sectionInput.getAttribute('data-section-id');
    const mobileQuantityInput = document.getElementById(`Quantity-Mobile-${sectionId}`);
    const regularQuantityInput = document.getElementById(`Quantity-${sectionId}`);
    const mobilePriceElement = document.getElementById('MobileCartPrice');
    const regularPriceElement = document.querySelector('.price__regular .price-item');
    
    if (!mobileQuantityInput || !regularQuantityInput) return;
    
    // 初期価格を設定
    if (mobilePriceElement && regularPriceElement) {
      mobilePriceElement.textContent = regularPriceElement.textContent;
    }
    
    // 数量連動（双方向）
    mobileQuantityInput.addEventListener('input', function() {
      regularQuantityInput.value = this.value;
      regularQuantityInput.dispatchEvent(new Event('change'));
    });
    
    regularQuantityInput.addEventListener('change', function() {
      mobileQuantityInput.value = this.value;
    });
    
    // モバイル数量ボタンの処理
    const mobileQuantityButtons = document.querySelectorAll('.mobile-fixed-cart-quantity .quantity__button');
    
    // 既存のイベントリスナーを削除
    mobileQuantityButtons.forEach(button => {
      button.replaceWith(button.cloneNode(true));
    });
    
    // 新しいボタン要素を取得し直す
    const newMobileQuantityButtons = document.querySelectorAll('.mobile-fixed-cart-quantity .quantity__button');
    
    newMobileQuantityButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isPlus = this.getAttribute('name') === 'plus';
        const currentValue = parseInt(mobileQuantityInput.value, 10) || 1;
        const minValue = parseInt(mobileQuantityInput.getAttribute('min'), 10) || 1;
        
        let newValue;
        if (isPlus) {
          newValue = currentValue + 1;
        } else {
          newValue = Math.max(currentValue - 1, minValue);
        }
        
        // モバイル数量を更新
        mobileQuantityInput.value = newValue;
        
        // レギュラー数量を更新
        regularQuantityInput.value = newValue;
        
        // 変更イベントを発火
        regularQuantityInput.dispatchEvent(new Event('change'));
        mobileQuantityInput.dispatchEvent(new Event('input'));
      });
    });
    
    // バリアント変更時の価格更新
    document.addEventListener('variant:change', function(event) {
      const variant = event.detail.variant;
      const mobilePriceEl = document.getElementById('MobileCartPrice');
      const oldPriceEl = document.querySelector('.mobile-cart-price-old s');
      const badgeEl = document.querySelector('.badge.price__badge-sale');

      // 新価格更新
      if (mobilePriceEl) {
        const updatedPriceElement = document.querySelector('.price__regular .price-item');
        if (updatedPriceElement) {
          mobilePriceEl.textContent = updatedPriceElement.textContent;
        }
      }

      // 旧価格＆バッジの表示判定
      if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (oldPriceEl) {
          oldPriceEl.textContent = Shopify.formatMoney(variant.compare_at_price, window.Shopify.money_format);
          oldPriceEl.parentElement.style.display = 'inline-block';
        }
        if (badgeEl) {
          badgeEl.style.display = 'inline-block';
        }
      } else {
        if (oldPriceEl) oldPriceEl.parentElement.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
    });
  }
}

// コピー機能
function initCopyButtons() {
  document.querySelectorAll('.copy-button').forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-target');
      const text = document.getElementById(targetId).textContent;
      navigator.clipboard.writeText(text).then(() => {
        const messageElement = button.nextElementSibling;
        messageElement.style.display = 'block';
        setTimeout(() => {
          messageElement.style.display = 'none';
        }, 2000);
      }).catch(err => {
        console.error('テキストのコピーに失敗しました', err);
      });
    });
  });
}

// 商品テーブルタブ機能
function initProductTableTabs() {
  const tabs = document.querySelectorAll('.product-table-tab');
  const contents = document.querySelectorAll('.product-table-content');
  
  if (tabs.length === 0) return;
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // すべてのタブとコンテンツからactiveクラスを削除
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      
      // クリックされたタブと対応するコンテンツにactiveクラスを追加
      this.classList.add('active');
      const targetContent = document.getElementById(targetTab);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}

// 使用フロータブ機能
function initUsageFlowTabs() {
  const flowTabs = document.querySelectorAll('.usage-flow-tab');
  const flowContents = document.querySelectorAll('.usage-flow-content');
  
  if (flowTabs.length === 0) return;
  
  flowTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-flow-tab');
      
      // すべてのタブとコンテンツからactiveクラスを削除
      flowTabs.forEach(t => t.classList.remove('active'));
      flowContents.forEach(c => c.classList.remove('active'));
      
      // クリックされたタブと対応するコンテンツにactiveクラスを追加
      this.classList.add('active');
      const targetContent = document.getElementById(targetTab);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}

// 商品スライダー機能
function initProductSliders() {
  // 商品スライダー
  const productSlider = document.querySelector('#product');
  if (productSlider && typeof Splide !== 'undefined') {
    new Splide('#product', {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      padding: { left: '10%', right: '10%' },
      gap: '1rem',
      autoplay: true,
      interval: 9000,
      speed: 2500,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      arrows: false,
    }).mount();
  }
}

// 営業日計算機能（UTCズレ対策版）
function initBusinessDayCalculation() {
  const shippingElement = document.getElementById('shipping-date');
  if (!shippingElement) return;

  // ベース日（今日の日付）※時刻ブレ防止で0:00固定
  const baseDate = new Date();
  baseDate.setHours(0, 0, 0, 0);

  // カスタム休暇日
  const customHolidays = [
    '2024-08-05', '2024-08-20', '2024-12-27', '2024-12-30', '2024-12-31',
    '2025-01-01', '2025-01-02', '2025-01-03', '2025-02-11', '2025-02-24',
    '2025-03-20', '2025-04-29', '2025-05-03', '2025-05-04', '2025-05-05',
    '2025-05-06', '2025-07-21', '2025-08-11', '2025-08-12', '2025-08-13',
    '2025-08-14', '2025-09-15', '2025-09-23', '2025-10-13', '2025-11-03',
    '2025-11-23', '2025-11-24', '2025-12-26', '2025-12-29', '2025-12-30',
    '2025-12-31', '2026-01-02'
  ];

  // ローカル日付で YYYY-MM-DD を作る（UTCズレ防止）
  function toLocalYMD(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  // 日付をフォーマットする関数
  function formatDate(date) {
    const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日(${dayNames[date.getDay()]})`;
  }

  // 営業日を判定する関数
  function isBusinessDay(date) {
    const day = date.getDay();
    const formattedDate = toLocalYMD(date); // ←ここがUTC対策の肝

    // 土日を除外
    if (day === 0 || day === 6) return false;
    // 祝日を除外（ライブラリがあれば反映）
    if (window.JapaneseHolidays && JapaneseHolidays.isHoliday(date)) return false;
    // カスタム休暇日を除外
    if (customHolidays.includes(formattedDate)) return false;

    return true;
  }

  // 指定営業日後の日付を取得する関数
  function getFutureBusinessDate(startDate, businessDays) {
    let date = new Date(startDate);
    let count = 0;

    while (count < businessDays) {
      date.setDate(date.getDate() + 1);
      date.setHours(0, 0, 0, 0); // 念のため毎ループで0:00固定
      if (isBusinessDay(date)) {
        count++;
      }
    }

    return date;
  }

  // 3営業日後の日付を取得し、フォーマットして出力
  const futureDate = getFutureBusinessDate(baseDate, 3);
  shippingElement.textContent = formatDate(futureDate);
}


// お客様の声スライダー機能
function initVoiceSlider() {
  const voiceSlider = document.querySelector('.splide_voice_product');
  if (voiceSlider && typeof Splide !== 'undefined') {
    new Splide('.splide_voice_product', {
      rewind: true,
      type: 'loop',
      pagination: false,
      perPage: 3,
      gap: '1.5rem',
      fixedWidth: '40%',
      focus: 'center',
      interval: 4000,
      speed: 1000,
      breakpoints: {
        750: {
          fixedWidth: '60%',
        },
        500: {
          fixedWidth: '70%',
          arrows: false,
          pagination: true,
        },
      },
    }).mount();
  }
}

// IE対応
function initIEFallback() {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  
  // IE用のフォールバック処理
  const hiddenInput = document.querySelector('input[name="id"]');
  const noScriptInputWrapper = document.querySelector('.product-form__noscript-wrapper');
  const variantPicker = document.querySelector('variant-selects');
  
  if (hiddenInput && noScriptInputWrapper && variantPicker) {
    noScriptInputWrapper.innerHTML = noScriptInputWrapper.textContent;
    variantPicker.outerHTML = noScriptInputWrapper.outerHTML;
  }
}
